export default "__VITE_ASSET__7$rgGgp4__"